module.exports = __webpack_public_path__ + "img/case-study-sharedis.ba247a21.png";